import { useAuth } from './context/AuthContext';

export default function AppShell({ children }) {
    return <>{children}</>;
}
